import { EntityModel } from '@/interfaces'
import {
  ALL_PRICINGS_QUERY,
  CREATE_PRICING_MUTATION,
  DELETE_PRICING_MUTATION,
  FORCE_DELETE_PRICING_MUTATION,
  SINGLE_PRICING_QUERY,
  UPDATE_PRICING_MUTATION,
} from './graphql'
import travelPricingAgeGroupSettingsEntity from '@/entities/travelPricingAgeGroupSettings/entity'
import travelPricingCustomDataConfigEntity from '@/entities/travelPricingCustomDataConfig/entity'
import ratioTravelEntity from '@/entities/ratioTravel/entity'
import travelWebhookConfigEntity from '@/entities/travelWebhookConfig/entity'
import travelPricingBrandingEntity from '@/entities/travelPricingBranding/entity'
import travelBargainSettingsEntity from '@/entities/travelBargainSettings/entity'
import travelEsimSettingsEntity from '@/entities/travelEsimSettings/entity'
import travelPricingPassportConfigEntity from '@/entities/travelPricingPassportConfig/entity'
import travelPartnerEntity from '@/entities/travelPartner/entity'
import travelPricingCurrencyOverrideEntity from '@/entities/travelPricingCurrencyOverride/entity'

const travelPricingModel: EntityModel = {
  name: 'pricing',
  namePlural: 'pricings',
  uniqueName: 'travelPricing',
  uniqueNamePlural: 'travelPricings',
  path: 'travel/pricing/pricing',
  baseUrl: '/travel/pricing/pricings',
  translationPrefix: 'entities:travelPricing.',
  getDisplayName: (values: any) => {
    return 'Pricing'
  },
  gql: {
    getAll: ALL_PRICINGS_QUERY,
    getSingle: SINGLE_PRICING_QUERY,
    create: CREATE_PRICING_MUTATION,
    update: UPDATE_PRICING_MUTATION,
    delete: DELETE_PRICING_MUTATION,
    forceDelete: FORCE_DELETE_PRICING_MUTATION,
  },
  attributes: {
    ageGroupSettings: {
      name: 'ageGroupSettings',
      label: 'entities:travelPricing.attributes.ageGroupSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingAgeGroupSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    isTravelDocumentationAvailable: {
      name: 'isTravelDocumentationAvailable',
      label: 'entities:travelPricing.attributes.isTravelDocumentationAvailable.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    customDataConfig: {
      name: 'customDataConfig',
      label: 'entities:travelPricing.attributes.customDataConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingCustomDataConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    travels: {
      name: 'travels',
      label: 'entities:travelPricing.attributes.travels.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioTravelEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    webhookConfig: {
      name: 'webhookConfig',
      label: 'entities:travelPricing.attributes.webhookConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelWebhookConfigEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    branding: {
      name: 'branding',
      label: 'entities:travelPricing.attributes.branding.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingBrandingEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    bargainSettings: {
      name: 'bargainSettings',
      label: 'entities:travelPricing.attributes.bargainSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelBargainSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    esimSettings: {
      name: 'esimSettings',
      label: 'entities:travelPricing.attributes.esimSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelEsimSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    passportConfig: {
      name: 'passportConfig',
      label: 'entities:travelPricing.attributes.passportConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingPassportConfigEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    tourOperator: {
      name: 'tourOperator',
      label: 'entities:travelPricing.attributes.tourOperator.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPartnerEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    currencyOverride: {
      name: 'currencyOverride',
      label: 'entities:travelPricing.attributes.currencyOverride.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingCurrencyOverrideEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingModel
